import React from 'react'
import DiffViewer from 'react-diff-viewer'
import { Space } from 'antd'
import { useSelector } from 'react-redux'
import MarkdownRenderer from '../../../../../../../components/common/markdown-renderer/MarkdownRenderer'

/**
 * Reusable DiffViewer component for showing text differences
 */
const TextDiffViewer = ({ oldValue, newValue, showDiff = true }) => {
    const themeMode = useSelector(state => state.theme?.mode || 'light')
    const isDarkMode = themeMode === 'dark'

    if (showDiff) {
        return (
            <DiffViewer
                oldValue={oldValue}
                newValue={newValue}
                splitView={true}
                showDiffOnly={false}
                compareMethod='diffCss'
                hideLineNumbers={true}
                useDarkTheme={isDarkMode}
                styles={{
                    line: {
                        borderRadius: '16px',
                        overflow: 'hidden',
                    },
                    wordRemoved: {
                        borderRadius: '4px',
                    },
                    wordAdded: {
                        borderRadius: '4px',
                    },
                    marker: {
                        display: 'none',
                    },
                }}
            />
        )
    }

    return (
        <Space direction='vertical'>
            <MarkdownRenderer content={newValue} />
        </Space>
    )
}

export default TextDiffViewer
